import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTopPageChange = props => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return props.children;
};

export default ScrollTopPageChange;
